import { FORMAT_DECIMAL_VALUE, KEY_GENERATOR } from "../../../../functions/funtion";
import { dto_StartupPageLoadInfo } from "../../../../classes/dto-mobile-settings";
import { F_Fammily, Font } from "../../../../util/config-fonts";
import { Colors } from "../../../../util/colors";
import "../../../../styles/css/colopse.css";

function PgProductAddons({
  data = Object,
  OnClick = () => {},
  SectedButton = Number,
}) {
  return (
    <>
      {data.map((rs) => {
        return (
          <div key={KEY_GENERATOR()} className="pgProductDesc">
            <p style={{ fontFamily: F_Fammily.Medium, margin: 0 }}>
              {rs.AddOnDesc}
            </p>
            {rs.dtoDTOProductAddOnDetailList.map((data, i) => {
              return (
                <div
                  style={{
                    display: "flex",
                    padding: 5,
                    marginTop: 4,
                    marginBottom: 4,
                  }}
                  key={KEY_GENERATOR()}
                >
                  <input
                    type="checkbox"
                    value={data.USeqID}
                    name="Uom"
                    onClick={(e) => {
                      // data.IsChecked = e.currentTarget.checked;
                      OnClick(e, rs, data, i);
                    }}
                    defaultChecked={data.IsChecked}
                    style={{
                      marginRight: 5,
                      fontSize: Font.Heading,
                      color: Colors.ThemeBGcolor,
                      accentColor: Colors.ThemeBGcolor,
                      cursor: "pointer",
                    }}
                  />
                  <p
                    style={{
                      fontSize: Font.Description,
                      margin: 0,
                    }}
                    onClick={(e) => {
                      // data.IsChecked =
                      //   e.currentTarget.previousElementSibling.checked;
                      OnClick(e, rs, data, i);
                    }}
                  >
                    {data.AddOnProductDesc +
                      "   " +
                      dto_StartupPageLoadInfo.Currency +
                      " - " +
                      FORMAT_DECIMAL_VALUE(2, data.Price, 2)}
                  </p>
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
}
export default PgProductAddons;
